/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * Arbi API
 * OpenAPI spec version: 1.0.0
 */
import type { PipelineCandidateSequenceInfoStatus } from './pipelineCandidateSequenceInfoStatus';

/**
 * One sequence a pipeline candidate has an enrollment in (any status).
 *
 * Deduped per sequence server-side: a candidate re-enrolled in the same
 * sequence surfaces once, preferring the live enrollment's status.
 */
export interface PipelineCandidateSequenceInfo {
  sequence_id: string;
  name: string;
  status: PipelineCandidateSequenceInfoStatus;
}
